import React, { useEffect, useState } from 'react'
import { ChallengeContainer } from 'domain/feature/hub/challenge/ChallengeContainer'
import { GetFormat, useGet } from 'sharedKernel/api'
import { trans } from 'sharedKernel/i18n'
import { Challenge } from 'data/contracts'
import { NoContent } from 'components/NoContent'
import { Loading } from 'components/loading'
import NoContentImg from 'assets/images/defaults/no_ideas.png'
import { PageDescription, PageTitle } from 'domain/feature/hub/pageTitle/styles'
import { FilterOrderBar } from 'sharedKernel/styledComponents/filterComponents/style'
import { Filter } from 'components/Filter'
import { FilterOrderByProps, OrderBy } from 'components/OrderBy'
import { showModal } from 'components/popup'
import { PendingUpdateAlert } from './PendingUpdateAlert'
import { MobileContainerPadding } from './style'
import { useSmartNavigateLegacy as useNavigate } from 'components/SmartLink'
import { cookies, setCookie } from 'sharedKernel/cookies/behavior'
import { getCredLocalStorage } from 'sharedKernel/auth/credLocalStorage'
import { loggedUser } from 'sharedKernel/user/LoggedUser'
import { TReducers, useSelector } from 'store'

export const HubStartupChallengePage = ({ ...props }): JSX.Element => {
  const navigate = useNavigate()
  const userPermissions = useSelector((state: TReducers) => state.auth.permissions)
  const user = loggedUser.get()
  const [IsRequiredUpdate, setIsRequiredUpdate] = useState<boolean>(false)

  const request: GetFormat = {
    url: '/v1/hub/resolver/challenge?page=1'
  }

  const orderByOptions = [
    {
      value: 'updated_at desc',
      label: trans('Mais recente')
    },
    {
      value: 'config.title',
      label: trans('Ordem alfabética')
    }
  ]

  const { data, isFetching, refetch } = useGet<Challenge[]>(request, 'startup-challenges')
  const [selectedOrderBy, setSelectedOrderBy] = useState(orderByOptions[0])
  const [currentSearchTerm, setCurrentSearchTerm] = useState<string>('')

  const renderModalUpdateCompanyInformation = (): void => {
    showModal('confirmation-update', {
      title: 'Atualização cadastral pendente!',
      message: 'Para manter seu acesso regularizado, é nescessário atualizar seu cadastro.',
      onConfirm: () => {
        navigate('/hub/user-config')
      },
      onCancel: () => {
        setCookie('_banner_update_late', true)
      }
    })
  }

  const ResolverRequiredUpdate = (): boolean => {
    const raw = cookies.get('_userUpdatedAt')
    const simplified = getCredLocalStorage()?.startupInfo?.isSimplifiedResolver ?? false
    const cookieDate = new Date(raw)
    const userUpdatedAtFromCookie = isNaN(cookieDate.getTime()) ? null : cookieDate

    const userUpdatedAtFromServer = new Date(user.updatedAt)
    const lastUpdatedAt = userUpdatedAtFromCookie ?? userUpdatedAtFromServer

    const isResolver = userPermissions?.features?.some(f => f.code === 'idea') ?? false
    const dataLimit = new Date('2025-07-27T07:00:00.000Z')

    return isResolver && (simplified || (lastUpdatedAt <= dataLimit))
  }

  useEffect(() => {
    if (isFetching) { return }

    const updateLate = cookies.get('_banner_update_late') === 'true'
    const IsRequiredUpdate = ResolverRequiredUpdate()
    setIsRequiredUpdate(IsRequiredUpdate)

    if (IsRequiredUpdate && !updateLate) {
      renderModalUpdateCompanyInformation()
    }
  }, [isFetching])

  const labels = {
    noContent: trans('Não há nenhum programa aberto no momento.'),
    loading: trans('Carregando...'),
    title: trans('Programas e Chamadas'),
    description: trans('Encontre programas de inovação e chamadas públicas (CPSI)')
  }

  const onSearch = (searchTerm: string): void => {
    request.httpConfig = { params: { match: searchTerm } }
    setCurrentSearchTerm(searchTerm)
    refetch()
  }

  const onOrderBy = (selectedOrderBy: FilterOrderByProps): void => {
    request.httpConfig = { params: { sort: selectedOrderBy.value } }
    setSelectedOrderBy(selectedOrderBy)
    refetch()
  }

  const renderPageHeader = (): JSX.Element => {
    return (
      <>
        <PageTitle>{labels.title}</PageTitle>
        <PageDescription>{labels.description}</PageDescription>
        <FilterOrderBar>
          <Filter currentSearchTerm={currentSearchTerm} btnClick={onSearch} />
          <OrderBy selectedValue={selectedOrderBy} onSelect={onOrderBy} options={orderByOptions} />
        </FilterOrderBar>
      </>
    )
  }

  if (isFetching) {
    return <Loading />
  }

  if (data == null || data?.rows.length < 1) {
    return (
      <>
        <MobileContainerPadding />
        {renderPageHeader()}
        <NoContent text={labels.noContent} image={NoContentImg} />
      </>
    )
  }

  return (
    <>
      <MobileContainerPadding />
      {IsRequiredUpdate && <PendingUpdateAlert />}
      {renderPageHeader()}
      <ChallengeContainer challenges={data.rows} />
    </>
  )
}
